import { menuDividerSelector, menuItemSelector, menuSelector, submenuSelector } from "@szhsin/react-menu/style-utils";
import styled from "styled-components";

import { BorderColorDefault, InteractiveColorDisabled, InteractiveColorHoverAlt } from "ds/Alias";
import { BorderRadius200, FontSize25, ShadowHigh } from "ds/Core/src/tokens";

export const StyledMenuWrapper = styled.div`
  position: relative;
  z-index: 100000;

  ${menuSelector.name} {
    box-sizing: border-box;
    z-index: 100;
    list-style: none;
    user-select: none;
    font-size: ${FontSize25};
    background-color: white;
    border-color: ${BorderColorDefault};
    box-shadow: ${ShadowHigh};
    border-radius: ${BorderRadius200};
    min-width: 160px;
    max-width: 300px;
  }

  ${menuSelector.name}:focus,${menuItemSelector.name}:focus {
    outline: none;
  }

  ${menuItemSelector.name} {
    cursor: pointer;
    border-radius: ${BorderRadius200};
    padding: 5px 12px;
    margin: 0 6px;

    // submenu chevron
    &:after {
      display: none;
    }
  }

  ${menuItemSelector.hover} {
    background-color: ${InteractiveColorHoverAlt};
  }

  ${menuItemSelector.disabled} {
    cursor: default;
    color: ${InteractiveColorDisabled};
  }

  ${submenuSelector.name} > ${menuItemSelector.name} {
    padding-right: 12px;
  }

  ${menuDividerSelector.name} {
    height: 1px;
    margin: 6px 0;
    background-color: ${BorderColorDefault};
  }

  .search-wrapper {
    padding: 0 0 0 10px;
    background-color: white !important;

    & > div {
      width: calc(100% - 4px);
    }
  }
`;
